import React from "react";
import { NavLink } from "react-router-dom";

export default function DatabaseManagementSolutions() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Database Management Solutions</h1>
            <h5 className="text-muted">
              Secure, Scalable, and Streamlined Data Management for Your Business
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Intro */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/database-storage-concept-illustration_114360-706.jpg"
              alt="Database Management"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Empowering Data-Driven Decisions</h2>
            <p>
              <strong>Bytlas Intelligence</strong> offers robust database management solutions that help you store, organize, retrieve, and protect critical business data. From MySQL and MS SQL to cloud-native databases, we ensure your data architecture supports growth and resilience.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Database Design, Normalization & Indexing</li>
              <li className="list-group-item">✅ Secure Backup & Recovery Plans</li>
              <li className="list-group-item">✅ Performance Optimization & Query Tuning</li>
              <li className="list-group-item">✅ Cloud & On-Premise Database Setup</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">What We Offer</h3>
            <ul>
              <li>🧮 Custom Database Development</li>
              <li>🛡️ Access Control & Data Encryption</li>
              <li>🔁 Data Migration & Integration</li>
              <li>📊 Real-time Reporting Integration</li>
              <li>📂 Database Maintenance & Support</li>
            </ul>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Why Choose Bytlas?</h3>
            <p>
              We blend security, scalability, and performance into every database solution we deliver. Our team ensures minimal downtime and smooth operations, whether it's an enterprise ERP backend or a lightweight CMS.
            </p>
            <ul>
              <li>🚀 Fast Deployment & Minimal Disruption</li>
              <li>🛠️ Skilled Experts in SQL, NoSQL & Cloud DBs</li>
              <li>📞 Ongoing Maintenance & SLA-based Support</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Schedule a Database Consultation
          </NavLink>
        </div>
      </div>
    </section>
  );
}
